import Page from './index';

export default { path: '/home/tenant/tenantSpconfig', component: Page };
